import type { CustomCellRendererProps } from "ag-grid-react";

import { Tooltip } from "@synthesis/shared-ui";

import { useApplicationDictionariesContext } from "../../application-detail-page/application-dictionaries-context";
import { getApplicationRailwayDisplay, type ApplicationsTableItem } from "../applications-page.lib";

export const ApplicationRailwayCell = ({ data }: CustomCellRendererProps<ApplicationsTableItem>) => {
  const { dictionaries } = useApplicationDictionariesContext();
  const displayValue = getApplicationRailwayDisplay(data, dictionaries.railways);

  return (
    <Tooltip description={displayValue} arrowSide="top">
      <span>{displayValue}</span>
    </Tooltip>
  );
};
